import request from '@/src/apis/axios';

import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  GetInquiriesRequestParams,
  GetInquiryByIdRequestParams,
  PostInquiryAnswerRequestBody,
} from './inquiry.dtos';
import InquiryDto from '@/src/models/InquiryDto';

const URL = {
  inquiry: '/admin/inquiries',
  inquiryDetail: '/admin/inquiries/{id}',
  inquiryCategory: '/inquiry/category',
  inquiryAnswer: '/admin/inquiries/answer',
};

// 1:1 문의 카테고리 리스트 조회
export const getInquiryCategoriesAPI = async () => {
  const { data } = await request<ObjectResponse<Record<string, string>>>({
    method: 'get',
    url: URL.inquiryCategory,
  });

  return Object.values(data?.row || []);
};

// 1:1 문의 리스트 조회
export const getInquiriesAPI = async (
  requestParams: Partial<GetInquiriesRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<InquiryDto>>({
    method: 'get',
    url: URL.inquiry,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(InquiryDto, data.rows);

  return { rows, count: data.count };
};

// 1:1 문의 상세 답변 등록
export const getInquiryByIdAPI = async (
  requestParams: GetInquiryByIdRequestParams,
) => {
  const { id } = requestParams;

  const { data } = await request<ObjectResponse<InquiryDto>>({
    method: 'get',
    url: URL.inquiryDetail.replace('{id}', String(id)),
  });

  return plainToInstance(InquiryDto, data.row);
};

// 1:1 문의 생성
export const postInquiryAnswerAPI = async (
  requestBody: PostInquiryAnswerRequestBody,
) => {
  const { data } = await request<ObjectResponse<InquiryDto>>({
    method: 'post',
    url: URL.inquiryAnswer,
    requestBody: { ...requestBody },
  });

  return plainToInstance(InquiryDto, data.row);
};
